import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import Divider from '../../../../components/ui/divider/Divider';
import IntroGraphic from '../../../../assets/graphics/Intro';
import { SectionProps } from '../../index';

import useStyles from './style';

export default function Intro(props: SectionProps) {
  const { ref, inView } = useInView({
    threshold: .2,
  });

  useEffect(() => {
    props.showChange(props.index, inView);
  }, [inView, props]);

  const classes = useStyles();

  return (
    <div
      ref={ref}
      className={classes.root}>
      <div className={classes.wrapper}>
        {inView &&
          <div className={classes.content}>
            <h1 className={classes.title}>
              Lucasmellof
            </h1>

            <Divider />

            <h2 className={classes.subTitle}>
              Kotlin and Java developer
            </h2>

            <h2 className={classes.subTitleSecond}>
              focused in backend systems
            </h2>
          </div>
        }

        <div className={classes.graphicWrapper}>
          {inView &&
            <IntroGraphic />
          }
        </div>
      </div>
    </div>
  );
}